import { assertString } from '@/libs/utils'
import { defineRule } from '../define-rule'
import { isValidDate } from '@/utils/date-util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type DateIsValidRuleConstructorParams = BaseRuleConstructorParams<
  { dateFormat?: string } | undefined
>

export const dateIsValid = defineRule(
  'date_is_valid',
  ({ config = {}, errorMessage }: DateIsValidRuleConstructorParams) => {
    const { dateFormat = 'DD.MM.YYYY' } = config
    const error = errorMessage ?? false
    return (value: unknown) => {
      try {
        assertString(value)
        return isValidDate(value as string, dateFormat) || error
      } catch (e) {
        console.error('Error while executing dateIsValid', e)
        return error
      }
    }
  }
)
